export default "__VITE_ASSET__CD9vaKSK__"